module.exports = __webpack_public_path__ + "static/img/06-add-app-by-url.6b2784e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lti-setup-guide/06-add-app-by-url.png
// module id = /ffW
// module chunks = 1